import {MANIFEST_POST_CANCEL} from "../axios";

export const axiosPostAnnulateMan = async (axiosPrivate, manId, body, getRequestDataToggle, cargoCaseDocId, getIdCreateDoc, getIdUpdateMan, setActiveModalSuccess, setActiveModalAnnulate, setTextMessage, setModalMessage) => {
    try {
        const response = await axiosPrivate.post(MANIFEST_POST_CANCEL + manId,
            JSON.stringify(body))
        let promise = new Promise((resolve, reject) => {
            resolve(response)
        })
        promise.then(
            function (response) {
                getRequestDataToggle()
                return new Promise((resolve, reject) => {
                    resolve(response)
                })
            }).then(
            function (response) {
                if (cargoCaseDocId !== undefined) {
                    getIdCreateDoc(cargoCaseDocId)
                    getIdUpdateMan(manId)
                } else {
                    getIdUpdateMan(manId)
                }
            }).catch(
            function (error) {
                console.log(error)
            })
        setModalMessage('Successful document cancellation!');
        setTextMessage('');
        setActiveModalSuccess(true);
        setActiveModalAnnulate(false);
    } catch (err) {
        console.log(err);
        setActiveModalAnnulate(false);
        setTextMessage('Document invalidation error! Try again!');
    }
}
